import React, { useState } from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import ServerFormErrors from "../../util/ServerFormErrors";
import ax from "../../util/axios";
import { useIntl } from "react-intl";

const AddApprovedOrganisationForm = (props) => {
  const intl = useIntl();
  const [errorMessage, setErrorMessages] = useState();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { ...props.defaultValues } });
  const onSubmit = (data) => {
    ax({
      method: props.method || "POST",
      url: props.url,
      data: { form: data },
    })
      .then(function () {
        window.location = window.location.href;
      })
      .catch((err) => {
        setErrorMessages(err.response.data);
      });
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <label>{intl.formatMessage({ id: "admin-area.scenarios.learning-outcome.outcome-field" })}</label>
          <textarea rows="5" className="form-control" {...register("outcome", { required: true })}></textarea>
          {errors.outcome?.type === "required" && (
            <div className="field-error">{intl.formatMessage({ id: "shared.forms.required" })}</div>
          )}
        </div>

        <div className="btn-group btn-end">
          <button type="submit" className="btn btn-primary small angled-bottom-right">
            {intl.formatMessage({ id: "shared.forms.save" })}
          </button>
        </div>
      </form>

      <ServerFormErrors errorMessages={errorMessage}></ServerFormErrors>
    </div>
  );
};

AddApprovedOrganisationForm.propTypes = {
  url: PropTypes.string.isRequired,
  defaultValues: PropTypes.object,
  method: PropTypes.string,
};

export default AddApprovedOrganisationForm;
